import { Button, Link } from "@softmax/design-system";
import type { ReplayViewerKind } from "./replay-viewer-links";

export function ReplayDownload({
  viewer,
  downloadHref,
  onDownload,
  downloadPending = false,
}: Readonly<{
  onDownload: (() => void) | undefined;
  downloadPending: boolean | undefined;
  viewer: ReplayViewerKind;
  downloadHref: string | null;
}>) {
  if (!downloadHref || (viewer === "mettascope" && !onDownload)) return null;

  if (onDownload)
    return (
      <Button
        size="sm"
        variant="quiet"
        onClick={onDownload}
        disabled={downloadPending}
        focusableWhenDisabled
      >
        {downloadPending ? "Downloading…" : "Download Replay"}
      </Button>
    );

  return (
    <Link
      focus="native"
      href={downloadHref}
      download={viewer === "coworld"}
      target="_blank"
      rel="noopener noreferrer"
    >
      Download Replay
    </Link>
  );
}
